"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPremiumBand = formatPremiumBand;
exports.formatIssueAgeBonus = formatIssueAgeBonus;
exports.bestPremiumBonus = bestPremiumBonus;
exports.premiumBandLabel = premiumBandLabel;
exports.issueAgeBonusLabel = issueAgeBonusLabel;
function formatDollars(amount) {
    const hasCents = Math.round(amount * 100) % 100 !== 0;
    return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: hasCents ? 2 : 0,
    });
}
function formatBandRange(minimum, maximum) {
    if (minimum == null && maximum == null)
        return null;
    if (minimum != null && minimum > 0 && maximum == null)
        return `${formatDollars(minimum)}+`;
    if (maximum != null && (minimum == null || minimum <= 0))
        return `Up to ${formatDollars(maximum)}`;
    if (minimum != null && maximum != null) {
        return `${formatDollars(minimum)}–${formatDollars(maximum)}`;
    }
    return null;
}
function formatPremiumBand(band) {
    const nonQualifiedMinimum = band.premiumMin_NQ ?? null;
    const qualifiedMinimum = band.premiumMin_QL ?? null;
    const maximum = band.premiumMax ?? null;
    if (nonQualifiedMinimum == null && qualifiedMinimum == null && maximum == null)
        return null;
    if (nonQualifiedMinimum === qualifiedMinimum ||
        qualifiedMinimum == null ||
        nonQualifiedMinimum == null) {
        return formatBandRange(nonQualifiedMinimum ?? qualifiedMinimum, maximum);
    }
    const nonQualifiedLabel = formatBandRange(nonQualifiedMinimum, maximum);
    const qualifiedLabel = formatBandRange(qualifiedMinimum, maximum);
    if (nonQualifiedLabel == null || qualifiedLabel == null)
        return nonQualifiedLabel ?? qualifiedLabel;
    return `NQ ${nonQualifiedLabel} / Q ${qualifiedLabel}`;
}
function formatIssueAgeBonus(bonus) {
    if (bonus.fromAge == null && bonus.toAge == null)
        return null;
    if (bonus.fromAge != null && bonus.toAge == null)
        return `Issue age ${bonus.fromAge}+`;
    if ((bonus.fromAge == null || bonus.fromAge <= 0) && bonus.toAge != null) {
        return `Issue age ${bonus.toAge} and under`;
    }
    if (bonus.fromAge != null && bonus.toAge != null) {
        return `Issue age ${bonus.fromAge}–${bonus.toAge}`;
    }
    return null;
}
/** The bonus with the highest rate: the figure the cards and table display. */
function bestPremiumBonus(bonuses) {
    let best = null;
    for (const bonus of bonuses ?? []) {
        if (bonus.theRate != null && bonus.theRate > 0 && bonus.theRate > (best?.theRate ?? 0)) {
            best = bonus;
        }
    }
    return best;
}
function isSP500Account(account) {
    const name = (account.name ?? '').toUpperCase();
    const source = (account.accountSourceCode ?? '').toUpperCase();
    return (name.includes('S&P') ||
        name.includes('SP500') ||
        source.includes('SP500') ||
        source.includes('S&P'));
}
/** Band label for the S&P 500 account when it has one, else the first labeled band. */
function premiumBandLabel(accounts) {
    const labeled = [];
    for (const account of (accounts ?? [])) {
        for (const band of account.bands ?? []) {
            const label = formatPremiumBand(band);
            if (label)
                labeled.push({ account, label });
        }
    }
    return (labeled.find(({ account }) => isSP500Account(account)) ?? labeled[0])?.label ?? null;
}
/** Issue-age label of the bonus that is displayed (the highest rate). */
function issueAgeBonusLabel(bonuses) {
    const best = bestPremiumBonus(bonuses);
    return best ? formatIssueAgeBonus(best) : null;
}
//# sourceMappingURL=rate-bands.js.map